import { privateAxios } from '@/common/api/axios'
import { PriceSurveyData, PriceSurveyResponse } from '@/features/priceSurvey/types/priceSurvey.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UsePriceSurveyProps = {
  id: string
}

type UsePriceSurveyType = (props: UsePriceSurveyProps) => UseQueryResult<PriceSurveyData, unknown>

export const usePriceSurvey: UsePriceSurveyType = ({ id }) => {
  return useQuery<PriceSurveyResponse, unknown, PriceSurveyData>({
    queryKey: ['priceSurvey', id],
    queryFn: () => {
      return privateAxios.get(`/price_surveys/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
